export default 'car';
